<!--
 * @Description: 关联关系(对象)
-->
<template>
  <div>
    <el-row class="mb-10px">
      <el-input
        class="w-200px"
        size="small"
        v-model="serchRelationKeyWord"
        @keyup.native.enter="serchRelationList"
        :placeholder="$t('pleaseEnterFileName')"
        clearable
      ></el-input>
      <el-button type="primary" size="small" @click="serchRelationList" class="!ml-10px">{{
        $t('search')
      }}</el-button>
      <el-button size="small" @click="isRemoveRelationList()" type="danger" class="!ml-10px">{{
        `${$t('DisRelation')}`
      }}</el-button>
      <el-button
        class="!ml-10px"
        size="small"
        @click="openHandelRelationDialog"
        data-cy="openHandelRelationDialog"
        >{{ `${$t('ManualAssociation')}` }}</el-button
      >
    </el-row>
    <el-table
      :data="relationTable"
      @selection-change="selectRelationItem"
      border
      height="281px"
      highlight-current-row
      stripe
    >
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column
        prop="documentClassName"
        show-overflow-tooltip
        :label="`${$t('type')}`"
      ></el-table-column>
      <el-table-column
        prop="documentName"
        show-overflow-tooltip
        :label="`${$t('DocumentName')}`"
      ></el-table-column>
      <el-table-column
        :label="$t('documentVersion')"
        prop="revision"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="fileName"
        show-overflow-tooltip
        :label="`${$t('FileName')}`"
      ></el-table-column>
      <el-table-column :label="`${$t('operate')}`" width="100">
        <template slot-scope="scope">
          <el-popover placement="top" v-model="scope.row.removeRelation">
            <p class="mb-10px">{{ `${$t('WhetherToDisassociate')}` }}？</p>
            <div class="tr">
              <el-button size="mini" type="text" @click="scope.row.removeRelation = false">{{
                `${$t('Cancel')}`
              }}</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="isRemoveRelation([scope.row.tagFileAssociationId], scope.$index)"
                >{{ `${$t('Sure')}` }}</el-button
              >
            </div>
            <el-button size="mini" slot="reference">{{ $t('disassociate') }}</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 手动关联 -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="handelRelationDialog"
      @close="closeHandelDialog"
      data-cy="handleRelationDialog"
      :title="`${$t('ManualAssociation')}`"
      v-dialogDrag
    >
      <el-row type="flex" class="mb-20px">
        <el-input
          v-model.trim="relationSearch"
          @keyup.native.enter="getHandelList(1)"
          :placeholder="`${$t('PleaseEnterAKeyword')}`"
          class="mr-10px"
        ></el-input>
        <el-button type="primary" @click="getHandelList(1)">{{ `${$t('search')}` }}</el-button>
      </el-row>
      <el-table
        :data="handleData"
        v-loading="relativeLoading"
        border
        @selection-change="selectRelativeId"
        ref="handelTable"
        height="455px"
        highlight-current-row
        stripe
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          prop="fileName"
          sortable
          :label="$t('fileName')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="documentName"
          sortable
          :label="$t('documentName')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="$t('documentVersion')"
          prop="revision"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <div class="mt-20px tr">
        <el-pagination
          background
          @current-change="getHandelList"
          @size-change="getHandelList(1)"
          :current-page.sync="handelPageNo"
          :page-size.sync="handlePageSize"
          :page-sizes="[10, 15, 20, 50]"
          layout="->, total, sizes, prev, pager, next, jumper"
          :total="handelTotal"
          :pager-count="5"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRelation">{{ `${$t('save')}` }}</el-button>
        <el-button @click="closeHandelDialog">{{ `${$t('Cancel')}` }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import documentManagementService from '@/services/documentManagement'
import ApiMixinTags from '@/assets/js/api/tags'
import ApiMixinTagCategory from '@/assets/js/api/tagCategory'
import ApiMixinDocument from '@/assets/js/api/documents'
import FnMixins from '@/assets/js/fnMixins'
import ApiMixinCable from '@/assets/js/api/cableManagement'

export default {
  name: 'affiliationsTable',
  mixins: [ApiMixinTags, ApiMixinTagCategory, ApiMixinDocument, FnMixins, ApiMixinCable],
  props: {
    affiliationsTableProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      serchRelationKeyWord: '',
      relationTable: [], // 关联关系表格
      handelRelationDialog: false,
      handelPageNo: 1,
      handlePageSize: 15,
      handelTotal: 0,
      selectRelationItemById: [], // 编辑弹框中关联文档中的复选框值
      handleData: [], // 手动关联模态框表格数据
      relativeLoading: false, // 关联表格数据加载状态
      relationSearch: '', // 手动关联搜索
      files: [], // 手动关联选中的关联项
    }
  },
  watch: {
    'affiliationsTableProps.tableDetailData': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.id) {
          this.getRelationList()
        }
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    serchRelationList() {
      if (_.isEmpty(this.tempRelationTable)) {
        this.tempRelationTable = _.clone(this.relationTable)
      }
      if (this.serchRelationKeyWord === '') {
        this.relationTable = _.clone(this.tempRelationTable)
        return
      }
      this.relationTable = _.filter(this.tempRelationTable, (el) => {
        return el.fileName.includes(this.serchRelationKeyWord)
      })
    },
    // 获取关联关系的列表
    async getRelationList() {
      const res3 = await this.apiTags({
        method: 'docRelationFile',
        params: {
          id: this.affiliationsTableProps.tableDetailData.id,
          standardId: this.affiliationsTableProps.standardId,
        },
      })
      if (res3 && res3.data && res3.code === 0) {
        this.relationTable = []
        const nodeList = _.map(res3.data, (item) => {
          _.map(item.childrenNodes, (aItem) => {
            aItem.documentClassName = item.nodeName
            aItem.revision = item.revision
            return aItem
          })
          return item
        })
        _.map(nodeList, (item) => {
          this.relationTable = this.relationTable.concat(item.childrenNodes)
        })
        _.map(this.relationTable, (item) => {
          item.fileName = item.nodeName
          return item
        })
      }
    },
    // 解除关联
    isRemoveRelationList() {
      if (this.selectRelationItemById.length) {
        const idList = []
        _.forEach(this.selectRelationItemById, (el) => {
          idList.push(el.tagFileAssociationId)
        })
        this.$confirm(this.$t('WhetherToDisassociate'), this.$t('hint'), {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        })
          .then(async () => {
            const res = await this.apiTags({
              method: 'DetachAssociationByTagAndFileList',
              params: idList,
            })
            if (res && res.code === 0) {
              this.relationTable = _.filter(this.relationTable, (el) => {
                return !idList.includes(el.tagFileAssociationId)
              })
              if (!_.isEmpty(this.tempRelationTable)) {
                this.tempRelationTable = _.filter(this.tempRelationTable, (el) => {
                  return !idList.includes(el.tagFileAssociationId)
                })
              }
              this.$message.success(this.$t('successfulDeAssociation'))
            }
          })
          .catch(() => {})
      } else {
        this.$message.warning(this.$t('selectUnassociate'))
      }
    },
    // 打开手动关联模态框
    openHandelRelationDialog() {
      this.getHandelList()
      this.handelRelationDialog = true
    },
    // 关闭手动关联模态框
    closeHandelDialog() {
      this.handelRelationDialog = false
      this.handelPageNo = 1
      this.files = []
      this.$refs.handelTable.clearSelection()
    },
    selectRelationItem(item) {
      this.selectRelationItemById = item
    },
    // 获取选中得关联id
    selectRelativeId(selection) {
      selection.forEach((item) => {
        item.fileId = item.id
      })
      this.files = selection
    },
    // 获取手动关联列表
    async getHandelList(type) {
      if (type === 1) {
        this.handelPageNo = 1
      }
      this.relativeLoading = true
      this.apiTags({
        method: 'getFileList',
        params: {
          StandardId: this.affiliationsTableProps.standardId,
          SkipCount: (this.handelPageNo - 1) * this.handlePageSize,
          MaxResultCount: this.handlePageSize,
          KeyWord: this.relationSearch ? this.relationSearch : ' ',
        },
        extra: { errorMsg: false },
      }).then((res) => {
        if (res && res.code === 0 && res.data) {
          this.handleData = res.data
          this.handelTotal = res.totalCount
          this.$nextTick(() => {
            this.$refs.handelTable.doLayout()
          })
        } else {
          this.handleData = []
          this.handelTotal = 0
        }
        this.relativeLoading = false
      })
    },
    // 点击手动关联确定按钮，判断是否已经有关联关系，如果有则提示，没有则push
    async saveRelation() {
      if (this.files.length) {
        const arr = []
        const flagArr = []
        this.relationTable.forEach((item) => {
          arr.push(item.fileId)
        })
        this.files.forEach((val) => {
          const check = val.fileId
          if (_.includes(arr, check)) {
            flagArr.push(false)
          } else {
            flagArr.push(true)
          }
        })
        // 从新勾选的项和这边表格已选项是否有重叠的
        if (_.every(flagArr, Boolean)) {
          this.relationTable = this.relationTable.concat(this.files).splice(0)
          this.tempRelationTable = _.clone(this.relationTable)
          this.serchRelationKeyWord = ''
          this.handelRelationDialog = false
        } else {
          this.$message.warning(`${this.$t('ThereIsanAssociatedRelationshipPleaseReselect')}`)
        }
        const ids = _.map(this.files, (item) => {
          return item.id
        })
        const res = await documentManagementService.saveTagFileAssociationList({
          documentFileIds: ids,
          tagId: this.affiliationsTableProps.tableDetailData.id,
          standardId: this.affiliationsTableProps.standardId,
        })
        if (res && res.code === 0) {
          this.$message.success(this.$t('associationSuccessful'))
          this.getRelationList()
        }
      } else {
        this.$message.warning(`${this.$t('PleaseSelectTheFileYouWantToAssociate')}`)
      }
    },
    // 解除关联关系
    isRemoveRelation(fileIdList, index) {
      this.apiTags({
        method: 'DetachAssociationByTagAndFileList',
        params: fileIdList,
      }).then(async (res) => {
        if (res && res.code === 0) {
          this.relationTable[index].removeRelation = false
          this.relationTable.splice(index, 1)
          if (!_.isEmpty(this.tempRelationTable)) {
            this.tempRelationTable = _.filter(this.tempRelationTable, (el) => {
              return el.isRemoveRelation !== fileIdList[0]
            })
          }
          this.$message.success(this.$t('successfulDeAssociation'))
        }
      })
    },
  },
}
</script>

<style>

</style>
